import {
  FETCH_NAGRA_CANDIDATES_REQUEST,
  FETCH_NAGRA_CANDIDATES_SUCCESS,
  FETCH_NAGRA_CANDIDATES_FAILURE,
  FETCH_NAGRA_BATCH_REQUEST,
  FETCH_NAGRA_BATCH_SUCCESS,
  FETCH_NAGRA_BATCH_FAILURE,
  REMOVE_NAGRA_BATCH_CANDIDATE,
  FETCH_NAGRA_CANDIDATE_REQUEST,
  FETCH_NAGRA_CANDIDATE_SUCCESS,
  FETCH_NAGRA_CANDIDATE_FAILURE,
  UPDATE_NAGRA_CANDIDATE_REQUEST,
  UPDATE_NAGRA_CANDIDATE_SUCCESS,
  UPDATE_NAGRA_CANDIDATE_FAILURE,
  UPLOAD_NAGRA_SCREENSHOT_REQUEST,
  UPLOAD_NAGRA_SCREENSHOT_SUCCESS,
  UPLOAD_NAGRA_SCREENSHOT_FAILURE,
  SUBMIT_NAGRA_CANDIDATE_REQUEST,
  SUBMIT_NAGRA_CANDIDATE_SUCCESS,
  SUBMIT_NAGRA_CANDIDATE_FAILURE,
  FETCH_NAGRA_MANUAL_CANDIDATES_REQUEST,
  FETCH_NAGRA_MANUAL_CANDIDATES_SUCCESS,
  FETCH_NAGRA_MANUAL_CANDIDATES_FAILURE,
  CREATE_NAGRA_MANUAL_CANDIDATE_REQUEST,
  CREATE_NAGRA_MANUAL_CANDIDATE_SUCCESS,
  CREATE_NAGRA_MANUAL_CANDIDATE_FAILURE,
} from '../../actionTypes';
import * as api from '../../apiHelper';
import { arriveNotice } from '../../noticeActions';

// --- Reducer corresponding actions ---

export function fetchNagraCandidatesRequest() {
  return { type: FETCH_NAGRA_CANDIDATES_REQUEST };
}
export function fetchNagraCandidatesSuccess(candidates, total, page, limit) {
  return {
    type: FETCH_NAGRA_CANDIDATES_SUCCESS,
    payload: {
      candidates,
      total,
      page,
      limit,
    },
  };
}
export function fetchNagraCandidatesFailure(error) {
  return { type: FETCH_NAGRA_CANDIDATES_FAILURE, payload: { error } };
}

export function fetchNagraBatchRequest() {
  return { type: FETCH_NAGRA_BATCH_REQUEST };
}
export function fetchNagraBatchSuccess(batch, message, statusTotals, activeOperations) {
  return {
    type: FETCH_NAGRA_BATCH_SUCCESS,
    payload: {
      batch,
      message,
      statusTotals,
      activeOperations,
    },
  };
}
export function fetchNagraBatchFailure(error) {
  return { type: FETCH_NAGRA_BATCH_FAILURE, payload: { error } };
}
export function removeNagraBatchCandidate(id) {
  return { type: REMOVE_NAGRA_BATCH_CANDIDATE, payload: { id } };
}

export function fetchNagraCandidateRequest() {
  return { type: FETCH_NAGRA_CANDIDATE_REQUEST };
}
export function fetchNagraCandidateSuccess(candidate) {
  return { type: FETCH_NAGRA_CANDIDATE_SUCCESS, payload: { candidate } };
}
export function fetchNagraCandidateFailure(error) {
  return { type: FETCH_NAGRA_CANDIDATE_FAILURE, payload: { error } };
}

export function updateNagraCandidateRequest() {
  return { type: UPDATE_NAGRA_CANDIDATE_REQUEST };
}
export function updateNagraCandidateSuccess(candidate) {
  return { type: UPDATE_NAGRA_CANDIDATE_SUCCESS, payload: { candidate } };
}
export function updateNagraCandidateFailure(error) {
  return { type: UPDATE_NAGRA_CANDIDATE_FAILURE, payload: { error } };
}

export function uploadNagraScreenshotRequest() {
  return { type: UPLOAD_NAGRA_SCREENSHOT_REQUEST };
}
export function uploadNagraScreenshotSuccess(screenshotS3Urls) {
  return { type: UPLOAD_NAGRA_SCREENSHOT_SUCCESS, payload: { screenshotS3Urls } };
}
export function uploadNagraScreenshotFailure(error) {
  return { type: UPLOAD_NAGRA_SCREENSHOT_FAILURE, payload: { error } };
}

export function submitNagraCandidateRequest() {
  return { type: SUBMIT_NAGRA_CANDIDATE_REQUEST };
}
export function submitNagraCandidateSuccess(candidate) {
  return { type: SUBMIT_NAGRA_CANDIDATE_SUCCESS, payload: { candidate } };
}
export function submitNagraCandidateFailure(error) {
  return { type: SUBMIT_NAGRA_CANDIDATE_FAILURE, payload: { error } };
}

export function fetchNagraManualCandidatesRequest() {
  return { type: FETCH_NAGRA_MANUAL_CANDIDATES_REQUEST };
}
export function fetchNagraManualCandidatesSuccess(result) {
  return { type: FETCH_NAGRA_MANUAL_CANDIDATES_SUCCESS, payload: result };
}
export function fetchNagraManualCandidatesFailure(error) {
  return { type: FETCH_NAGRA_MANUAL_CANDIDATES_FAILURE, payload: { error } };
}

export function createNagraManualCandidateRequest() {
  return { type: CREATE_NAGRA_MANUAL_CANDIDATE_REQUEST };
}
export function createNagraManualCandidateSuccess(candidate) {
  return { type: CREATE_NAGRA_MANUAL_CANDIDATE_SUCCESS, payload: { candidate } };
}
export function createNagraManualCandidateFailure(error) {
  return { type: CREATE_NAGRA_MANUAL_CANDIDATE_FAILURE, payload: { error } };
}

// --- API functions ---

async function fetchNagraCandidatesApi(token, params, dispatch) {
  const queryParams = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') queryParams.set(k, String(v));
  });
  const qs = queryParams.toString();
  const response = await api.get({
    path: qs ? `nagra/candidates?${qs}` : 'nagra/candidates',
    version: 'gateway',
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

async function fetchNagraCandidateApi(token, id, dispatch) {
  const response = await api.get({
    path: `nagra/candidates/${id}`,
    version: 'gateway',
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json.data ?? json);
}

async function updateNagraCandidateApi(token, id, updates, dispatch) {
  const response = await api.put({
    path: `nagra/candidates/${id}`,
    version: 'gateway',
    body: updates,
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json.data ?? json);
}

async function updateCandidateStatusApi(token, id, body, dispatch) {
  const response = await api.put({
    path: `nagra/candidates/${id}/status`,
    version: 'gateway',
    body,
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json.data ?? json);
}

async function submitCandidateApi(token, id, dispatch) {
  const response = await api.post({
    path: `nagra/candidates/${id}/submit`,
    version: 'gateway',
    body: {},
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json.data ?? json);
}

async function uploadNagraScreenshotApi(token, id, file, dispatch) {
  const response = await api.uploadFile({
    path: `nagra/candidates/${id}/screenshot`,
    version: 'gateway',
    file,
    token,
    dispatch,
    isAdminRoute: true,
    method: 'POST',
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

async function createManualCandidateApi(token, body, dispatch) {
  const response = await api.post({
    path: 'nagra/candidates/manual',
    version: 'gateway',
    body,
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json.data ?? json);
}

// --- Public component actions ---

export function fetchNagraCandidates(params = {}) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      dispatch(fetchNagraCandidatesRequest());
      const result = await fetchNagraCandidatesApi(adminToken, params, dispatch);
      dispatch(fetchNagraCandidatesSuccess(
        result.data || [],
        result.total || 0,
        result.page || 1,
        result.limit || 20,
      ));
    } catch (e) {
      dispatch(fetchNagraCandidatesFailure(e.message));
      dispatch(arriveNotice(e.message));
    }
  };
}

export function fetchNagraBatch() {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      dispatch(fetchNagraBatchRequest());
      const result = await fetchNagraCandidatesApi(adminToken, { batch: 'true' }, dispatch);
      dispatch(fetchNagraBatchSuccess(
        result.data || [],
        result.message || null,
        result.statusTotals || null,
        result.activeOperations || null,
      ));
      if (result.message === 'Review queue is empty') {
        dispatch(arriveNotice('Review queue is empty.', 'ok'));
      }
    } catch (e) {
      dispatch(fetchNagraBatchFailure(e.message));
      dispatch(arriveNotice(e.message));
    }
  };
}

export function approveAndSubmitNagraBatchCandidate(id) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      await submitCandidateApi(adminToken, id, dispatch);
      dispatch(removeNagraBatchCandidate(id));
      dispatch(arriveNotice('Candidate approved and submitted.', 'ok'));
    } catch (e) {
      dispatch(arriveNotice(e.message));
    }
  };
}

export function rejectNagraBatchCandidate(id) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      // eslint-disable-next-line camelcase
      await updateCandidateStatusApi(adminToken, id, { review_status: 'rejected', rejection_reason: 'Rejected from batch review queue' }, dispatch);
      dispatch(removeNagraBatchCandidate(id));
      dispatch(arriveNotice('Candidate rejected.', 'ok'));
    } catch (e) {
      dispatch(arriveNotice(e.message));
    }
  };
}

export function fetchNagraCandidate(id) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      dispatch(fetchNagraCandidateRequest());
      const candidate = await fetchNagraCandidateApi(adminToken, id, dispatch);
      dispatch(fetchNagraCandidateSuccess(candidate));
    } catch (e) {
      dispatch(fetchNagraCandidateFailure(e.message));
      dispatch(arriveNotice(e.message));
    }
  };
}

export function updateNagraCandidate(id, updates) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      dispatch(updateNagraCandidateRequest());
      const candidate = await updateNagraCandidateApi(adminToken, id, updates, dispatch);
      dispatch(updateNagraCandidateSuccess(candidate));
      dispatch(arriveNotice('Candidate saved successfully.', 'ok'));
    } catch (e) {
      dispatch(updateNagraCandidateFailure(e.message));
      dispatch(arriveNotice(e.message));
    }
  };
}

export function updateNagraCandidateStatus(id, body) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      dispatch(updateNagraCandidateRequest());
      const candidate = await updateCandidateStatusApi(adminToken, id, body, dispatch);
      dispatch(updateNagraCandidateSuccess(candidate));
      dispatch(arriveNotice('Candidate status updated.', 'ok'));
    } catch (e) {
      dispatch(updateNagraCandidateFailure(e.message));
      dispatch(arriveNotice(e.message));
    }
  };
}

export function submitNagraCandidate(id) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      dispatch(submitNagraCandidateRequest());
      const candidate = await submitCandidateApi(adminToken, id, dispatch);
      dispatch(submitNagraCandidateSuccess(candidate));
      dispatch(arriveNotice('Candidate submitted to NAGRA successfully.', 'ok'));
    } catch (e) {
      dispatch(submitNagraCandidateFailure(e.message));
      dispatch(arriveNotice(e.message));
    }
  };
}

export function fetchNagraManualCandidates(params = {}) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      dispatch(fetchNagraManualCandidatesRequest());
      const result = await fetchNagraCandidatesApi(adminToken, params, dispatch);
      dispatch(fetchNagraManualCandidatesSuccess(result));
    } catch (e) {
      dispatch(fetchNagraManualCandidatesFailure(e.message));
      dispatch(arriveNotice(e.message));
    }
  };
}

export function createNagraManualCandidate(body, onSuccess) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      dispatch(createNagraManualCandidateRequest());
      const candidate = await createManualCandidateApi(adminToken, body, dispatch);
      dispatch(createNagraManualCandidateSuccess(candidate));
      dispatch(arriveNotice('Manual candidate created successfully.', 'ok'));
      if (onSuccess) onSuccess(candidate);
    } catch (e) {
      dispatch(createNagraManualCandidateFailure(e.message));
      dispatch(arriveNotice(e.message));
    }
  };
}

export function uploadNagraScreenshot(id, file) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      dispatch(uploadNagraScreenshotRequest());
      const result = await uploadNagraScreenshotApi(adminToken, id, file, dispatch);
      dispatch(uploadNagraScreenshotSuccess(result.screenshotS3Urls));
      dispatch(arriveNotice('Screenshot uploaded successfully.', 'ok'));
    } catch (e) {
      dispatch(uploadNagraScreenshotFailure(e.message));
      dispatch(arriveNotice(e.message));
    }
  };
}
